import { render } from "./SwitchOwner.vue?vue&type=template&id=1c3f558a"
import script from "./SwitchOwner.vue?vue&type=script&lang=js"
export * from "./SwitchOwner.vue?vue&type=script&lang=js"

import "./SwitchOwner.vue?vue&type=style&index=0&id=1c3f558a&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_a3ee6c512411489faef2ecfce652dcca/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__